import { render, staticRenderFns } from "./PasswordPrompt.vue?vue&type=template&id=6b52e474&scoped=true&"
import script from "./PasswordPrompt.vue?vue&type=script&lang=js&"
export * from "./PasswordPrompt.vue?vue&type=script&lang=js&"
import style0 from "./PasswordPrompt.vue?vue&type=style&index=0&id=6b52e474&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b52e474",
  null
  
)

export default component.exports